import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    idTC: '',
    termsAndConditionsUrl: '',
    privacyUrl: '', 
    idPrivacyPolicy: '',
    isLoading: false
};

export const termsAndConditionsSlice = createSlice({
    name: 'termsAndConditions',
    initialState,
    reducers:{
        resetTermsAndConditionsState: () => initialState  
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'GetTermsAndConditions')
                {         
                    state.idTC = action.payload.response.listOfTC[0].idTC
                    state.termsAndConditionsUrl = action.payload.response.listOfTC[0].URL
                    state.privacyUrl = action.payload.response.privacyPolicy.url    
                    state.idPrivacyPolicy = action.payload.response.privacyPolicy.idPrivacyPolicy 
                }
            })
    },
})
export const { resetTermsAndConditionsState } = termsAndConditionsSlice.actions;

export const selectTermsAndConditionsState = (state) => state.termsAndConditions;

export default termsAndConditionsSlice.reducer;

